import {cardIcon, visaIcon, mastercardLogo} from '@img'

export default function CardBrand({brand, className = 'w-12', alt}) {
    const b = (brand || '').toLowerCase()
    if (b === 'visa') return <img src={visaIcon} alt={alt || 'visa'} className={className}/>
    if (b === 'mastercard' || b === 'master' || b === 'master_card') return <img src={mastercardLogo} alt={alt || 'mastercard'} className={className}/>
    return <img src={cardIcon} alt={alt || 'card'} className={className}/>
}
